
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","data-prefix":"far","data-icon":"alarm-clock","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M256 64C132.26 64 32 164.29 32 288a222.69 222.69 0 0044.75 134l-40.1 40.09a16 16 0 000 22.63l22.63 22.62a16 16 0 0022.62 0l40.1-40.12a222.82 222.82 0 00268 0l40.1 40.09a16 16 0 0022.63 0l22.62-22.62a16 16 0 000-22.63L435.21 422A222.7 222.7 0 00480 288c0-123.71-100.3-224-224-224zm0 400a176 176 0 11176-176 176 176 0 01-176 176zM96 0A96 96 0 000 96a94.81 94.81 0 0015.3 51.26L161.2 25.68A95.63 95.63 0 0096 0zm184 292.47V168a8 8 0 00-8-8h-32a8 8 0 00-8 8v132.16a32 32 0 0012 25l64.54 51.57a8.58 8.58 0 005.87 1.72 8 8 0 005.35-2.95l20-25a8 8 0 00-1.25-11.27zM416 0a95.66 95.66 0 00-65.18 25.66l145.89 121.57A94.85 94.85 0 00512 96a96 96 0 00-96-96z"}})])
          )
        }
      }
    